import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Card, Box, IconButton, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  OpenInNew as OpenInNewIcon,
  Add as AddIcon,
  Edit,
} from "@mui/icons-material";
import { GetLinksRoleByCountry } from "../../redux/actions/GetLinksRoleByCountryAction";
import { GetLinksByCountry } from "../../redux/actions/GetLinksByCountryAction";
import { GetActiveRolesByCountry } from "../../redux/actions/GetActiveRolesByCountryAction";
import AddLinkRoleModal from "components/AddLinkRoleModal";
import EditLinkRoleModal from "components/EditLinkRoleModal";

const LinksRoleTable = () => {
  const dispatch = useDispatch();
  const linksRoleResponse = useSelector((state) => state.linksRole.linksRole);
  const status = useSelector((state) => state.linksRole.status);
  const linksResponse = useSelector((state) => state.links.links);
  const rolesResponse = useSelector((state) => state.activeRoles.roles);
  const [linksRole, setLinksRole] = useState([]);
  const [roles, setRoles] = useState([]);
  const [links, setLinks] = useState([]);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedLinkRole, setSelectedLinkRole] = useState(null);

  useEffect(() => {
    if (linksRoleResponse) {
      const listLinksRole = linksRoleResponse.map((element) => ({
        id: element.idLinkRole,
        idLinkRole: element.idLinkRole,
        idRole: element.idRole,
        roleName: element.roleName,
        idLink: element.idLink,
        link: element.link,
        url: element.url,
      }));

      setLinksRole(listLinksRole);
    }
  }, [linksRoleResponse]);

  useEffect(() => {
    if (rolesResponse?.length > 0) {
      const listRoles = rolesResponse.map((role) => ({
        idRole: role.idrole ?? role.idRole,
        roleName: role.roleName,
      }));
      setRoles(listRoles);
    }
  }, [rolesResponse]);

  useEffect(() => {
    if (linksResponse?.length > 0) {
      const listLinks = linksResponse.map((link) => ({
        idLink: link.idMenuLevel3Links ?? link.idLink,
        linkName: link.linkName ?? link.name,
      }));
      setLinks(listLinks);
    }
  }, [linksResponse]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(GetLinksRoleByCountry());
      await dispatch(GetLinksByCountry());
      await dispatch(GetActiveRolesByCountry());
    };

    fetchData();
  }, [dispatch]);

  const handleEditOpen = (row) => {
    setSelectedLinkRole(row);
    setOpenEditModal(true);
  };

  const columns = [
    {
      field: "idLinkRole",
      headerName: "ID",
      flex: 0.8,
      minWidth: 110,
    },
    {
      field: "roleName",
      headerName: "Role",
      flex: 1,
      minWidth: 140,
    },
    {
      field: "link",
      headerName: "Link",
      flex: 1.5,
      minWidth: 180,
    },
    {
      field: "url",
      headerName: "URL",
      flex: 2.5,
      minWidth: 220,
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value}
          </span>
          <IconButton
            size="small"
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
          >
            <OpenInNewIcon fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="contained"
          sx={{
            color: "#ffffff",
            backgroundColor: "#4b4bfa",
            "&:hover": {
              backgroundColor: "#3e3ed9",
            },
          }}
          onClick={() => handleEditOpen(params.row)}
        >
          <Edit />
        </Button>
      ),
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <div style={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
              }}
            >
              <h1 style={{ marginBottom: "0.5%" }}>Links by Role</h1>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#4b4bfa",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#3e3ed9",
                  },
                }}
                onClick={() => setOpenAddModal(true)}
              >
                <AddIcon />
              </Button>
            </Box>
            <DataGrid
              rows={linksRole}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[5, 10, 20]}
              disableSelectionOnClick
              loading={status === "loading"}
              sx={{
                width: "100%",
                "& .MuiCircularProgress-root": {
                  color: "#4b4bfa",
                },
                mt: 2,
              }}
            />
          </div>
        </Card>
      </Grid>

      <AddLinkRoleModal
        roles={roles}
        links={links}
        open={openAddModal}
        onClose={() => setOpenAddModal(false)}
      />
      <EditLinkRoleModal
        roles={roles}
        links={links}
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);
          setSelectedLinkRole(null);
        }}
        linkRoleData={selectedLinkRole}
      />
    </Grid>
  );
};

export default LinksRoleTable;
